import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ffccce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page padding-top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "horizontal-center center",
  style: {"margin":"0px","padding-top":"20px"}
}, " Log Out ", -1))
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Unable to log out due to a communication error. Please check your connection and try again. ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Are you sure you want to log out?", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Logging Out ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Yes, Log Out")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cancel ")

import api from "@virgodev/bazaar/functions/api";
import { nextTick, ref, watch } from "vue";
import { useRouter } from "vue-router";
import goBackOrToRoute from "@/methods/go_back_or_to_route";
import scrollToFirstError from "@/methods/scroll_to_first_error";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const status = ref<"idle" | "logging_out" | "error">("idle");

watch(status, () => {
  if (status.value === "error") {
    nextTick(scrollToFirstError);
  }
});

async function logOut() {
  status.value = "logging_out";
  const responseData = await api({
    url: "users/logout/",
    method: "POST",
  });

  if (responseData.status === 204) {
    store.logOut();
    router.push({ name: "login" });
  } else {
    status.value = "error";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_TransitionSlide = _resolveComponent("TransitionSlide")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TransitionSlide, { mode: "out-in" }, {
        default: _withCtx(() => [
          (status.value === 'error')
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 0,
                variant: "danger",
                class: "js-form-error",
                dismissible: "",
                onDismissed: _cache[0] || (_cache[0] = ($event: any) => (status.value = 'idle'))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(_component_BaseButton, {
        class: "btn btn-text",
        disabled: status.value === 'logging_out',
        onClick: logOut
      }, {
        default: _withCtx(() => [
          (status.value === 'logging_out')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_6,
                _createVNode(_component_BaseSpinner)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_7
              ], 64))
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_BaseButton, {
        class: "btn btn-text",
        disabled: status.value === 'logging_out',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goBackOrToRoute)('Home')))
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})